import { EscortProfile } from '@/types';

export const mockEscorts: EscortProfile[] = [
  {
    id: '1',
    userId: '101',
    displayName: 'Sophia Rose',
    age: 24,
    location: {
      city: 'Paris',
      country: 'France',
      workingLocations: ['Paris', 'Nice', 'Cannes']
    },
    bio: {
      short: 'Elegant and sophisticated companion with a passion for art and fine dining.',
      full: 'I am Sophia, an elegant Parisian companion with a deep appreciation for art, culture, and intellectual conversations. With my soft-spoken nature and attentive demeanor, I create an atmosphere of relaxed sophistication. I enjoy fine dining, art exhibitions, and romantic evenings. My clients appreciate my genuine smile, engaging conversation, and the way I make them feel completely at ease. I believe in quality over quantity, offering discreet companionship with a personal touch. Every encounter with me is unique and tailored to create unforgettable moments of connection and pleasure.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Caucasian',
      nationality: 'French',
      height: 174,
      weight: 57,
      eyeColor: 'Blue',
      hairColor: 'Blonde',
      bodyType: 'Slim',
      measurements: '86-60-90',
      cupSize: 'C',
      intimateArea: 'Natural',
      tattoos: false,
      piercings: true,
      smoking: 'Occasionally',
      drinking: 'Socially',
      languages: [
        { name: 'French', level: 5 },
        { name: 'English', level: 4 },
        { name: 'Italian', level: 2 }
      ],
      sexualOrientation: 'Bisexual',
      interestedIn: ['Men', 'Women', 'Couples']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Overnight', visibility: 'teaser' },
      { name: 'Weekend', visibility: 'teaser' },
      { name: 'Travel Companion', visibility: 'teaser' },
      { name: 'GFE', visibility: 'regular' },
      { name: 'Massage', visibility: 'regular' },
      { name: 'Roleplay', visibility: 'vip' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 300, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 500, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 800, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1500, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 3500, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+33 7XX XX XX XX',
      contactMethod: 'SMS + Call',
      availability: 'Mon-Sun',
      availableHours: '11:00 - 23:00'
    },
    fanSubscriptionPrice: 29.99,
    isTouring: true,
    tourDates: [
      {
        location: 'London',
        startDate: new Date(2024, 5, 15),
        endDate: new Date(2024, 5, 20)
      },
      {
        location: 'Monaco',
        startDate: new Date(2024, 6, 8),
        endDate: new Date(2024, 6, 15)
      }
    ],
    isVerified: true,
    isOnline: true
  },
  {
    id: '2',
    userId: '102',
    displayName: 'Mia Milano',
    age: 28,
    location: {
      city: 'Milan',
      country: 'Italy',
      workingLocations: ['Milan', 'Rome', 'Venice']
    },
    bio: {
      short: 'Italian model with a fiery personality and passion for adventure.',
      full: 'Ciao! I am Mia, a stylish Italian model with a vibrant personality and insatiable curiosity. Born and raised in Milan, I embody the Italian passion for life, food, and romance. I adore adventure, whether it\'s exploring hidden gems in ancient cities or embarking on spontaneous weekend getaways. My playful nature and genuine interest in people make every encounter both exciting and comfortable. I pride myself on creating authentic connections, filled with laughter, intellectual conversation, and genuine affection. When not traveling or modeling, I enjoy cooking traditional Italian dishes and practicing yoga to maintain my toned physique.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Mediterranean',
      nationality: 'Italian',
      height: 168,
      weight: 54,
      eyeColor: 'Brown',
      hairColor: 'Brunette',
      bodyType: 'Athletic',
      measurements: '90-58-88',
      cupSize: 'D',
      intimateArea: 'Shaved',
      tattoos: true,
      piercings: true,
      smoking: 'No',
      drinking: 'Occasionally',
      languages: [
        { name: 'Italian', level: 5 },
        { name: 'English', level: 4 },
        { name: 'Spanish', level: 3 }
      ],
      sexualOrientation: 'Heterosexual',
      interestedIn: ['Men']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Overnight', visibility: 'teaser' },
      { name: 'Travel Companion', visibility: 'teaser' },
      { name: 'GFE', visibility: 'regular' },
      { name: 'Fantasy', visibility: 'vip' },
      { name: 'BDSM', visibility: 'vip' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 350, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 600, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 900, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1800, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 4000, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+39 3XX XXX XXX',
      contactMethod: 'WhatsApp',
      availability: 'Tue-Sun',
      availableHours: '12:00 - 02:00'
    },
    fanSubscriptionPrice: 39.99,
    isTouring: false,
    isVerified: true,
    isOnline: false
  },
  {
    id: '3',
    userId: '103',
    displayName: 'Emma Laurent',
    age: 22,
    location: {
      city: 'Lyon',
      country: 'France'
    },
    bio: {
      short: 'Young French student with a sweet personality and intellectual mind.',
      full: 'Bonjour! I\'m Emma, a university student from Lyon with a passion for literature and philosophy. Behind my sweet, innocent appearance lies a curious mind and adventurous spirit. I offer an authentic girlfriend experience with genuine emotions and connections. As a part-time model and full-time dreamer, I enjoy intellectual conversations as much as playful moments. My natural beauty and youthful energy create a refreshing experience. When we meet, expect engaging discussions, heartfelt laughter, and a genuine connection that feels like we\'ve known each other for years.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Caucasian',
      nationality: 'French',
      height: 165,
      weight: 50,
      eyeColor: 'Green',
      hairColor: 'Auburn',
      bodyType: 'Petite',
      measurements: '84-56-86',
      cupSize: 'B',
      intimateArea: 'Natural',
      tattoos: false,
      piercings: false,
      smoking: 'No',
      drinking: 'Occasionally',
      languages: [
        { name: 'French', level: 5 },
        { name: 'English', level: 3 }
      ],
      sexualOrientation: 'Bisexual',
      interestedIn: ['Men', 'Women']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Cultural Outings', visibility: 'teaser' },
      { name: 'GFE', visibility: 'regular' },
      { name: 'Overnight', visibility: 'regular' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 250, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 400, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 700, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1300, currency: '€', visibility: 'regular' }
    ],
    contactInfo: {
      phone: '+33 6XX XX XX XX',
      contactMethod: 'SMS only',
      availability: 'Thu-Mon',
      availableHours: '18:00 - 01:00'
    },
    fanSubscriptionPrice: 19.99,
    isTouring: false,
    isVerified: true,
    isOnline: true
  },
  {
    id: '4',
    userId: '104',
    displayName: 'Viktoria',
    age: 26,
    location: {
      city: 'Prague',
      country: 'Czech Republic',
      workingLocations: ['Prague', 'Vienna', 'Berlin']
    },
    bio: {
      short: 'Eastern European beauty with model looks and a warm personality.',
      full: 'Hello, I am Viktoria from Prague. With my tall figure and natural beauty, I\'ve worked as a professional model across Europe. Beyond my appearance, I take pride in my intelligence and ability to engage in meaningful conversations on various topics. I love exploring new cities, enjoying fine dining, and experiencing cultural events. I\'m naturally curious and adventurous, always ready to try new experiences. My warm and open-minded nature makes everyone feel comfortable in my presence. I believe in creating genuine connections and unforgettable experiences with every encounter.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Slavic',
      nationality: 'Czech',
      height: 178,
      weight: 60,
      eyeColor: 'Blue',
      hairColor: 'Blonde',
      bodyType: 'Model',
      measurements: '92-62-90',
      cupSize: 'C',
      intimateArea: 'Shaved',
      tattoos: false,
      piercings: true,
      smoking: 'Occasionally',
      drinking: 'Socially',
      languages: [
        { name: 'Czech', level: 5 },
        { name: 'English', level: 4 },
        { name: 'German', level: 3 },
        { name: 'Russian', level: 3 }
      ],
      sexualOrientation: 'Heterosexual',
      interestedIn: ['Men']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Overnight', visibility: 'teaser' },
      { name: 'Weekend', visibility: 'teaser' },
      { name: 'Travel Companion', visibility: 'regular' },
      { name: 'GFE', visibility: 'regular' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 300, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 500, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 800, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1500, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 3500, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+420 6XX XXX XXX',
      contactMethod: 'Call',
      availability: 'Mon-Sun',
      availableHours: '10:00 - 22:00'
    },
    fanSubscriptionPrice: 24.99,
    isTouring: true,
    tourDates: [
      {
        location: 'Berlin',
        startDate: new Date(2024, 5, 25),
        endDate: new Date(2024, 5, 30)
      }
    ],
    isVerified: true,
    isOnline: false
  },
  {
    id: '5',
    userId: '105',
    displayName: 'Natasha',
    age: 29,
    location: {
      city: 'Moscow',
      country: 'Russia'
    },
    bio: {
      short: 'Russian beauty with sophistication and a background in ballet.',
      full: 'Privet! I am Natasha, a former ballet dancer from Moscow with grace that extends beyond the stage into every aspect of my life. My classical training has given me poise, discipline, and an appreciation for art and beauty. Intellectual and well-traveled, I enjoy deep conversations about literature, philosophy, and global affairs. I\'m fluent in several languages, making me an ideal companion for international travel. Whether attending a high-profile event or enjoying a quiet evening together, I adapt seamlessly to any situation with elegance and charm. My sensual nature and attention to detail ensure our time together will be nothing short of extraordinary.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Eastern European',
      nationality: 'Russian',
      height: 172,
      weight: 55,
      eyeColor: 'Gray',
      hairColor: 'Black',
      bodyType: 'Dancer',
      measurements: '88-59-89',
      cupSize: 'C',
      intimateArea: 'Shaped',
      tattoos: false,
      piercings: true,
      smoking: 'No',
      drinking: 'Occasionally',
      languages: [
        { name: 'Russian', level: 5 },
        { name: 'English', level: 4 },
        { name: 'French', level: 3 }
      ],
      sexualOrientation: 'Bisexual',
      interestedIn: ['Men', 'Women', 'Couples']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Cultural Events', visibility: 'teaser' },
      { name: 'Opera & Ballet', visibility: 'teaser' },
      { name: 'Overnight', visibility: 'regular' },
      { name: 'Travel Companion', visibility: 'regular' },
      { name: 'Couples', visibility: 'vip' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 400, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 700, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 1000, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 2000, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 4500, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+7 9XX XXX XX XX',
      contactMethod: 'Telegram',
      availability: 'Thu-Mon',
      availableHours: '14:00 - 02:00'
    },
    fanSubscriptionPrice: 49.99,
    isTouring: false,
    isVerified: true,
    isOnline: true
  },
  {
    id: '6',
    userId: '106',
    displayName: 'Isabella',
    age: 25,
    location: {
      city: 'Barcelona',
      country: 'Spain',
      workingLocations: ['Barcelona', 'Madrid', 'Ibiza']
    },
    bio: {
      short: 'Fiery Spanish beauty with a passion for dance and adventure.',
      full: 'Hola! I\'m Isabella, a spirited Spanish beauty with Andalusian roots. My passion for flamenco dancing has shaped my confident, expressive personality and given me a deep appreciation for Spanish culture and traditions. I love sharing my heritage, from tapas tours to hidden flamenco shows. Beyond dance, I\'m an adventurous spirit who enjoys everything from beachside relaxation to mountain hiking. My infectious laughter and playful nature create an atmosphere of fun and excitement wherever I go. I connect easily with people from all walks of life, making everyone feel special and valued. With me, expect passionate conversations, spontaneous adventures, and unforgettable moments.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Hispanic',
      nationality: 'Spanish',
      height: 167,
      weight: 53,
      eyeColor: 'Brown',
      hairColor: 'Black',
      bodyType: 'Athletic',
      measurements: '87-58-89',
      cupSize: 'C',
      intimateArea: 'Brazilian',
      tattoos: true,
      piercings: true,
      smoking: 'Occasionally',
      drinking: 'Socially',
      languages: [
        { name: 'Spanish', level: 5 },
        { name: 'English', level: 4 },
        { name: 'Portuguese', level: 2 }
      ],
      sexualOrientation: 'Heterosexual',
      interestedIn: ['Men']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Club Companion', visibility: 'teaser' },
      { name: 'Beach Day', visibility: 'teaser' },
      { name: 'Overnight', visibility: 'regular' },
      { name: 'Weekend', visibility: 'regular' },
      { name: 'GFE', visibility: 'regular' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 300, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 500, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 800, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1600, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 3800, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+34 6XX XXX XXX',
      contactMethod: 'WhatsApp',
      availability: 'Mon-Sun',
      availableHours: '13:00 - 03:00'
    },
    fanSubscriptionPrice: 29.99,
    isTouring: true,
    tourDates: [
      {
        location: 'Ibiza',
        startDate: new Date(2024, 6, 1),
        endDate: new Date(2024, 6, 15)
      }
    ],
    isVerified: true,
    isOnline: true
  },
  {
    id: '7',
    userId: '107',
    displayName: 'Jenna',
    age: 27,
    location: {
      city: 'Amsterdam',
      country: 'Netherlands'
    },
    bio: {
      short: 'Dutch model with an open mind and adventurous personality.',
      full: 'Hello, I\'m Jenna from Amsterdam. Being raised in one of the most liberal cities in the world has shaped my open-minded and progressive outlook on life. As a professional model, I\'ve traveled extensively and developed a deep appreciation for different cultures and lifestyles. I\'m naturally curious, always eager to explore new ideas and experiences. My friends describe me as free-spirited yet grounded, with an infectious laugh and ability to find joy in simple moments. I value genuine connections and believe that true chemistry comes from open communication and mutual respect. Whether we\'re exploring Amsterdam\'s famous museums or enjoying a cozy night in, I create space for authentic experiences and meaningful conversations.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Caucasian',
      nationality: 'Dutch',
      height: 176,
      weight: 58,
      eyeColor: 'Green',
      hairColor: 'Blonde',
      bodyType: 'Slim',
      measurements: '86-61-88',
      cupSize: 'B',
      intimateArea: 'Shaved',
      tattoos: true,
      piercings: true,
      smoking: 'Occasionally',
      drinking: 'Socially',
      languages: [
        { name: 'Dutch', level: 5 },
        { name: 'English', level: 5 },
        { name: 'German', level: 3 }
      ],
      sexualOrientation: 'Bisexual',
      interestedIn: ['Men', 'Women', 'Couples']
    },
    services: [
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'City Tour', visibility: 'teaser' },
      { name: 'Couples', visibility: 'regular' },
      { name: 'Overnight', visibility: 'regular' },
      { name: 'BDSM', visibility: 'vip' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '1 Hour', price: 300, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: '2 Hours', price: 500, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Dinner Date (4h)', price: 800, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 1500, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Couples (2h)', price: 800, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+31 6 XX XX XX XX',
      contactMethod: 'SMS + Call',
      availability: 'Wed-Sun',
      availableHours: '14:00 - 02:00'
    },
    fanSubscriptionPrice: 34.99,
    isTouring: false,
    isVerified: true,
    isOnline: false
  },
  {
    id: '8',
    userId: '108',
    displayName: 'Anastasia',
    age: 30,
    location: {
      city: 'Vienna',
      country: 'Austria'
    },
    bio: {
      short: 'Elegant Viennese escort with sophistication and class.',
      full: 'Grüß Gott! I am Anastasia, a refined companion from the cultural capital of Vienna. My upbringing in this city of music and art has instilled in me a deep appreciation for classical music, opera, and fine arts. I hold a degree in Art History and can offer insightful perspectives when visiting museums and galleries. Fluent in several languages, I move comfortably in international circles and high society events. I value intellectual stimulation as much as physical connection, believing that the most exquisite experiences engage both mind and body. My elegant appearance is complemented by impeccable manners and discretion. I pride myself on being a sophisticated companion who understands the importance of privacy and personal boundaries.'
    },
    attributes: {
      gender: 'Female',
      ethnicity: 'Mixed',
      nationality: 'Austrian',
      height: 170,
      weight: 56,
      eyeColor: 'Hazel',
      hairColor: 'Brown',
      bodyType: 'Slim',
      measurements: '85-60-88',
      cupSize: 'B',
      intimateArea: 'Natural',
      tattoos: false,
      piercings: false,
      smoking: 'No',
      drinking: 'Occasionally',
      languages: [
        { name: 'German', level: 5 },
        { name: 'English', level: 5 },
        { name: 'French', level: 4 },
        { name: 'Russian', level: 3 }
      ],
      sexualOrientation: 'Heterosexual',
      interestedIn: ['Men']
    },
    services: [
      { name: 'Cultural Events', visibility: 'teaser' },
      { name: 'Opera Companion', visibility: 'teaser' },
      { name: 'Dinner Date', visibility: 'teaser' },
      { name: 'Business Events', visibility: 'regular' },
      { name: 'Overnight', visibility: 'regular' },
      { name: 'Weekend', visibility: 'vip' }
    ],
    rates: [
      { id: '101', category: 'incall', description: '2 Hours', price: 600, currency: '€', visibility: 'teaser' },
      { id: '102', category: 'incall', description: 'Dinner Date (4h)', price: 1000, currency: '€', visibility: 'teaser' },
      { id: '103', category: 'incall', description: 'Opera/Event (5h)', price: 1200, currency: '€', visibility: 'teaser' },
      { id: '104', category: 'outcall', description: 'Overnight (12h)', price: 2000, currency: '€', visibility: 'regular' },
      { id: '105', category: 'outcall', description: 'Weekend', price: 4500, currency: '€', visibility: 'vip' }
    ],
    contactInfo: {
      phone: '+43 6XX XXX XXX',
      contactMethod: 'Email',
      availability: 'Tue-Sat',
      availableHours: '16:00 - 23:00'
    },
    fanSubscriptionPrice: 39.99,
    isTouring: false,
    isVerified: true,
    isOnline: true
  }
];

export const getEscorts = async (): Promise<EscortProfile[]> => {
  await new Promise(resolve => setTimeout(resolve, 500));
  return mockEscorts;
};

export const getEscortById = async (id: string): Promise<EscortProfile | null> => {
  await new Promise(resolve => setTimeout(resolve, 500));
  const escort = mockEscorts.find(escort => escort.id === id);
  return escort || null;
};
